import React, { useState, useRef, useEffect } from 'react';
import { Header as HefestoHeader } from '@gerdau/hefesto-mais-web/Header';
import useQueryParams from '../../../hooks/useQueryParams';
import { ScenarioType } from '../types';
import { UserDataLink } from '../../../services/UserEvaluation/types';
import { HeaderContainer, UserEvaluationContent } from './styles';
import RequestResult from '../RequestResult';
import StartValidation from '../StartValidation';
import LoadingModal from '../../../components/LoadingModal';
import RequestApprovalPanel from '../RequestApprovalPanel';
import { useUserEvaluationContext } from '../../../providers/userEvaluation.provider';

const UserEvaluationContainer: React.FC = () => {
  const [step, setStep] = useState(1);
  const scenarioType = useRef<ScenarioType>('none');
  const { setUserData, loading, userData } = useUserEvaluationContext();
  const userDataLink = useQueryParams(
    [
      'cnpj',
      'email',
      'prospectUserId',
      'requester',
      'token',
      'userName',
      'companyName',
      'bp',
      'phone'
    ],
    false
  ) as unknown as UserDataLink;

  useEffect(() => {
    if (userDataLink && areDifferent()) setUserData(userDataLink);
  }, [userDataLink]);

  const areDifferent = () => {
    if (
      !userData ||
      Object.keys(userData).length !== Object.keys(userDataLink).length
    ) {
      return true;
    }

    for (const key in userData) {
      if (!userData || Object.prototype.hasOwnProperty.call(userData, key)) {
        if (
          userData[key as keyof UserDataLink] !==
          userDataLink[key as keyof UserDataLink]
        ) {
          return true;
        }
      }
    }

    return false;
  };

  const handleNextStep = (scenario?: ScenarioType) => {
    if (scenario) scenarioType.current = scenario;
    setStep((prev) => prev + 1);
  };

  return (
    <>
      <HeaderContainer>
        <HefestoHeader
          showCartIcon={false}
          onClickHelp={() => false}
          onClickNotification={() => false}
          onClickCart={() => false}
          hasNotification={false}
          userName={''}
          menuLinks={[]}
          showCoinMenu={false}
        />
      </HeaderContainer>
      <UserEvaluationContent>
        {loading && (
          <LoadingModal
            enabled={loading}
            title="Aguarde alguns instantes"
            message="Enviando os dados..."
          />
        )}
        {step === 1 && userData && (
          <StartValidation onNext={handleNextStep}></StartValidation>
        )}
        {step === 2 && (
          <RequestApprovalPanel
            onNext={handleNextStep}
            currentScenario={scenarioType.current}
          ></RequestApprovalPanel>
        )}
        {step === 3 && (
          <RequestResult currentScenario={scenarioType.current}></RequestResult>
        )}
      </UserEvaluationContent>
    </>
  );
};

export default UserEvaluationContainer;
